"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveUnassignAction = exports.useUnassignCollectionDialog = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const abortable_fetch_1 = require("../../../utils/abortable-fetch");
const empty_component_1 = require("../../../utils/empty-component");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const collection_schema_1 = require("../collection-schema");
function useUnassignCollectionDialog(getUrl) {
    const callApi = (0, event_callback_hook_1.useEventCallback)((id, collectionId, formData) => {
        return (0, abortable_fetch_1.abortableFetch)(`${getUrl(id, collectionId)}`, {
            method: 'PUT',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            body: JSON.stringify(formData),
        });
    });
    return {
        callApi,
    };
}
exports.useUnassignCollectionDialog = useUnassignCollectionDialog;
function resolveUnassignAction(props) {
    return {
        hide: false,
        useApi: useUnassignCollectionDialog,
        Dialog: empty_component_1.EmptyComponent,
        label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__COLLECTION__UNASSIGN_LABEL", defaultMessage: "Odebrat" })),
        title: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__COLLECTION__UNASSIGN_TITLE", defaultMessage: "Odebrat" })),
        text: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__COLLECTION__DELETE_TEXT", defaultMessage: "Skute\u010Dn\u011B chcete odebrat polo\u017Eku?" })),
        initValues: (values) => values,
        dialogWidth: 400,
        useSchema: collection_schema_1.useValidationSchema,
        ...props,
    };
}
exports.resolveUnassignAction = resolveUnassignAction;
//# sourceMappingURL=unassign-collection-hook.js.map